require('angular').module('wowApp.common')
    .service('InStoreProductService', require('./instoreproduct.service'));



// WEBPACK FOOTER //
// ./src/common/products/index.js